import { connect, ConnectedProps } from 'react-redux'

import { hideNavigation } from 'redux/actions'
import NavLink from 'components/layout/mobile-menu/NavLink'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState): { flavour: RootState['layout']['flavour'], aol: RootState['aol']['name'] } => ({
  flavour: state.layout.flavour,
  aol: state.aol.name
})

const mapDispatchToProps = (dispatch: AppDispatch): { hideNavigation: () => ReturnType<AppDispatch> } => ({
  hideNavigation: () => dispatch(hideNavigation())
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type NavLinkContainerProps = ConnectedProps<typeof connector>

export default connector(NavLink)
